import { Group, Text, useMantineTheme } from '@mantine/core';
import { OffsiteLink } from 'components/OffsiteLink';
import { useThemeColors } from 'hooks/useThemeColors';
import { useTranslation } from 'next-i18next';
import { IoPlayCircle } from 'react-icons/io5';

interface Props {
  link: string;
}

export const TutorialLink = ({ link }: Props) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { themeColors } = useThemeColors();

  return (
    <OffsiteLink link={link} withIcon={false}>
      <Group gap={'xs'}>
        <IoPlayCircle size={40} color={theme.other.colors.action} />
        <Text c={themeColors.texts}>{t('watchVideoGuide')}</Text>
      </Group>
    </OffsiteLink>
  );
};
